<template>
  <div>
    <div class="logistics-top">
      <div class="logistics-person-mesg">
        <div class="logistics-phone">{{logisticslist.result && logisticslist.result.recipient_name}} {{logisticslist.result && logisticslist.result.recipient_phone}}</div>
        <div class="logistics-address">{{logisticslist.result && logisticslist.result.recipient_address}}</div>
      </div>
    </div>
    <div class="logistics-mesgbox111">
      <div class="logistics-mesgbox">
        <img class="logistics-img1" :src="logisticslist.result && logisticslist.result.thumb"></img>
        <div class="logistics-num">{{logisticslist.result && logisticslist.result.com}} {{logisticslist.result && logisticslist.result.num}}</div>
      <!--  <div class="logistics-copy" @click="copy">复制单号</div> -->
      </div>
      <div class="logistics-detaillist">
        <div :class="item.only ? 'logistics-detailbox2' :(item.end ? 'logistics-detailbox' : 'logistics-detailbox1')"
          v-for="(item,index) in logisticslist.result && logisticslist.result.info">
          <div class="logistics-detail-left" v-if="item.end">
            <div class="logistics-detail-dot"></div>
            <div class="logistics-detail-line1"></div>
          </div>
          <div class="logistics-detail-left" v-else-if="item.only">
            <div class="logistics-detail-dot"></div>
          </div>
          <div class="logistics-detail-left" v-else>
            <div class="logistics-detail-line"></div>
            <div class="logistics-detail-dot1"></div>
          </div>
          <div class="logistics-detail-right">
            <div :class="item.end ? 'logistics-detail-text' : (item.only ?  'logistics-detail-text' : 'logistics-detail-text1')">{{item.context}}</div>
            <div :class="item.end ?  'logistics-detail-time' : (item.only ?  'logistics-detail-time' : 'logistics-detail-time1')">{{item.ftime}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        logisticslist: {},
        orderno: ""
      }
    },
    created() {
      if (this.$route.query.orderno) {
        this.orderno = this.$route.query.orderno
      }
      console.log("this.orderno",this.orderno)
      this.request("getOrderShipping", {
        order_no: this.orderno
      })
    },
    mounted() {

    },
    methods: {
      //复制单号
      copy() {
        let that = this
        wx.setClipboardData({
          data: that.data.logisticslist.num,
          success: function(res) {
            wx.showToast({
              title: '复制成功',
            })
            console.log(res)
          }
        })
      },
      //接口
      request(type, requestData = {}) {
        let that = this
        let data = {}
        switch (type) {
          //获取物流信息
          case "getOrderShipping":
            httper.get('order/shipping', requestData, res => {
              if (res.code == 0) {
                let logisticslist1 = res.data[0]
                console.log("logisticslist1",res.data[0])
                if ((logisticslist1.result.info).length > 1) {
                  logisticslist1.result.info[0]["end"] = true
                  logisticslist1.result.info[(logisticslist1.result.info).length - 1]["start"] = true
                } else if ((logisticslist1.result.info).length = 1) {
                  logisticslist1.result.info[0]["only"] = true
                }
                that.logisticslist = logisticslist1
                console.log("that.logisticslist",that.logisticslist)
              } else {
                that.$toast({
                  message: res.message || '系统异常'
                })
              }

            }, true)
            break
        }
      },

    }
  }
</script>

<style>
  .logistics-top {
    width: 100%;
    height: 153px;
    background: #00A0E9;
    border-radius: 0px 0px 15px 15px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #ffffff;
  }

  .logistics-imgs {
    width: 58px;
    height: 58px;
    margin-right: 15px;
  }

  .logistics-imgs1 {
    width: 58px;
    height: 58px;
    margin-right: 15px;
    background-color: #ffffff;
  }

  .logistics-person-mesg {}

  .logistics-phone {}

  .logistics-address {}

  .logistics-mesgbox111 {
    position: absolute;
    top: 20%;
    width: 100%;
  }

  .logistics-mesgbox {
    width: calc(100% - 40px);
    margin: 0 20px 20px 20px;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    border-radius: 8px;
    background-color: #ffffff;
    padding: 30px 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .logistics-img1 {
    width: 57px;
    height: 21px;
    margin-right: 16px;
    /* background-color: #E13A56 */
  }

  .logistics-num {
    font-size: 13px;
    font-weight: bold;
    margin-right: 27px;
  }

  .logistics-copy {
    width: 46px;
    height: 19px;
    border: 1px solid #BFBFBF;
    border-radius: 2px;
    font-size: 9px;
    color: #bbbbbb;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logistics-detaillist {
    width: calc(100% - 40px);
    margin: 20px;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    border-radius:8px;
    background-color: #ffffff;
    padding: 15px;
    box-sizing: border-box;
  }

  .logistics-detailbox1 {
    display: flex;
    align-items: flex-end;
  }

  .logistics-detailbox2 {
    display: flex;
    align-items: center;
  }

  .logistics-detailbox {
    display: flex;
    align-items: flex-start;
  }

  .logistics-detail-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .logistics-detail-line {
    width: 1px;
    height: 76px;
    background: #D2D2D2;
    margin-left: -20px;
  }

  .logistics-detail-line1 {
    width: 1px;
    height: 110px;
    background: #D2D2D2;
    margin-left: -20px;
  }

  .logistics-detail-dot {
    width: 10px;
    height: 10px;
    background: #00A0E9;
    border-radius: 50%;
    margin-right: 20px;
  }

  .logistics-detail-dot1 {
    width: 10px;
    height: 10px;
    background: #D2D2D2;
    border-radius: 50%;
    margin-right: 20px;
  }

  .logistics-detail-right {
    display: flex;
    /* align-items: center; */
    justify-content: center;
    flex-direction: column;
  }

  .logistics-detail-text {
    font-size: 13px;
    color: #00A0E9;
    margin-bottom: 7px;
  }

  .logistics-detail-time {
    color: #666666;
    font-size: 9px;
  }

  .logistics-detail-text1 {
    font-size: 13px;
    color: #D2D2D2;
    margin-bottom: 7px;
  }

  .logistics-detail-time1 {
    color: #D2D2D2;
    font-size: 9px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/youlegou/youlegoulogistics.vue